import { structureCompatibleAddons } from '../../../util/Format.util';
import useLocalStorage from '../../hooks/useLocalStorage';
import { addAddOns, getCompatibleAddOns, removeAddOns } from '../../integration/addons.api';
import { CART_TYPE, SERVICE_GROUPS } from '../shared/Constants';

const localStore = useLocalStorage();
const { DUALPLAY } = SERVICE_GROUPS;
const { NEW_ACQUISITION } = CART_TYPE;
/**
 * @name getCompatibleAddons - Function for getting addon
 */
export const getCompatibleAddons = async offerId => {
  try {
    const variables = {
      offerId,
      reference: localStore.getLocalStorage('PROSPECTUUID'),
    };
    const addOnsData = await getCompatibleAddOns({ variables });
    const result = addOnsData?.map(addon => structureCompatibleAddons(addon));
    return result;
  } catch (err) {
    console.error(err);
    return null;
  }
};

/**
 * @name addAddOn - Function for adding selected addon to the cart
 */
export const addAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch
) => {
  setShowLoader(catalogCode);
  try {
    const prospect = localStore.getLocalStorage('PROSPECTUUID');
    const offerId = await rootState.cart?.offers?.filter(
      offer => offer.baseOffer?.serviceGroup === DUALPLAY
    )[0]?.id;

    const variables = {
      reference: prospect,
      catalogCode,
      offerId,
      cartType: NEW_ACQUISITION,
    };

    const data = await addAddOns({ graphql, variables });
    dispatch({ type: 'SET_CART', payload: data });
    setOfferSelected(catalogCode);
    setShowLoader(' ');
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const removeAddOn = async (
  graphql,
  catalogCode,
  rootState,
  setShowLoader,
  setOfferSelected,
  dispatch
) => {
  setShowLoader(catalogCode);
  try {
    const prospect = localStore.getLocalStorage('PROSPECTUUID');
    let offerId = 0;
    let addOnId = 0;
    const addOnArrays = rootState?.cart?.offers.filter(offer => offer.addOns !== undefined);
    const selectedAddOnArray = addOnArrays?.map(arr =>
      arr.addOns.filter(ele => {
        if (ele.catalogCode === catalogCode) {
          offerId = arr.id;
        }
        return ele.catalogCode === catalogCode;
      })
    );
    const targetArray = selectedAddOnArray.filter(ele => ele.length > 0)[0];
    addOnId = targetArray[0].id;

    const variables = {
      reference: prospect,
      offerId,
      addOnId,
      cartType: NEW_ACQUISITION,
    };
    const data = await removeAddOns({ graphql, variables });
    setOfferSelected(null);
    setShowLoader(' ');
    dispatch({ type: 'SET_CART', payload: data });
    return data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const onLoadAddons = (rootState, setOfferSelected) => {
  const addOnArrays = rootState?.cart?.offers.filter(
    offer => offer.addOns !== undefined && offer.baseOffer?.serviceGroup === DUALPLAY
  );
  const selectedAddOnArray = addOnArrays?.map(arr => arr?.addOns);
  const addons = selectedAddOnArray?.flat();
  const catalogCode = addons.find(ele => ele.catalogCode)?.catalogCode;
  setOfferSelected(catalogCode);
};
